/* eslint-disable @typescript-eslint/no-explicit-any */
import { HStack, TabPanel, TabPanels, VStack } from '@chakra-ui/react';
import { AiFillAppstore, AiOutlineRead } from 'react-icons/ai';
import { SlEarphones, SlHeart } from 'react-icons/sl';
import { Labeled } from '../../../../../packages/ui/components/molecules/Labeled';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { TopBookstoreMenu } from '../../components/organisms/TopBookstoreMenu';
import { MainTemplate } from '../../templates/MainTemplate';
import { ReceivedBooksTemplate } from './components/ReceivedBookTemplate';
import { RenderNativeTabs } from '../Home';
import { BestSellersBookTemplate } from './components/BestSellersBookTemplate';
import { useGetFavoritedBooksMutation, useMyReadingBooks } from '@partiu/api/bookstore/hooks';
import { BookGrid } from '../../components/organisms/BookGrid';

interface TabContentProps {
  type: string;
  label?: string;
  helpText: string;
  filter: Record<string, any>;
}

const TabContent: React.FC<TabContentProps> = ({ label, helpText, filter }) => (
  <TabPanel padding="0px">
    <VStack mt="20px" width="100%" align="flex-start">
      <Labeled labelSize="24px" paddingX="5%" labelColor="rgba(0,0,0,0.6)" label={label || ''} helpText={helpText} />
      {filter.is_best_seller ? <BestSellersBookTemplate filter={filter} /> : <ReceivedBooksTemplate filter={filter} />}
    </VStack>
  </TabPanel>
);

export function ReceivedBooksPage() {
  const { bookstoreTypes, recurringBook, slug } = useTheme();

  const tabs = [
    bookstoreTypes.includes('book') && { name: 'Livros Recebidos', icon: <AiFillAppstore /> },
    bookstoreTypes.includes('audiobook') && { name: 'Audiolivros Recebidos', icon: <SlEarphones /> },
    bookstoreTypes.includes('magazine') && { name: 'Revistas Recebidas', icon: <AiFillAppstore /> },
    { name: 'Lendo', icon: <AiOutlineRead /> },
    { name: 'Favoritos', icon: <SlHeart /> },
  ].filter(Boolean) as { name: string; icon: JSX.Element }[];

  const helpTexts = {
    bestSellers: 'Aqui você encontra os best sellers mais vendidos para você ler ao mês',
    book: recurringBook
      ? ['abrintbiblioteca', 'abrintrevistas'].includes(slug)
        ? 'Confira nossos livros dos mêses e aproveite!'
        : 'Aqui você encontra os livros adquiridos no seu combo mensalmente que serão seus para sempre!'
      : 'A cada recarga você recebe novos livros que serão seus para sempre',
    audiobook: recurringBook
      ? ['abrintbiblioteca', 'abrintrevistas'].includes(slug)
        ? 'Confira nossos audiolivros dos mêses e aproveite!'
        : 'Aqui você encontra os audiolivros adquiridos no seu combo mensalmente que serão seus para sempre!'
      : 'A cada recarga você recebe novos audiolivros que serão seus para sempre',
    magazine: recurringBook
      ? ['abrintbiblioteca', 'abrintrevistas'].includes(slug)
        ? 'Confira nossas revistas dos mêses e aproveite!'
        : 'Aqui você encontra as revistas adquiridas no seu combo mensalmente que serão seus para sempre!'
      : 'A cada recarga você recebe novas revistas que serão suas para sempre',
  };

  return (
    <MainTemplate noShadow hideTopMenu>
      <RenderNativeTabs />
      <TopBookstoreMenu tabs={tabs}>
        <TabPanels>
          {bookstoreTypes.includes('book') && (
            <TabContent type="book" helpText={helpTexts.book} filter={{ book__type: 'book' }} />
          )}
          {bookstoreTypes.includes('audiobook') && (
            <TabContent type="audiobook" helpText={helpTexts.audiobook} filter={{ book__type: 'audiobook' }} />
          )}
          {bookstoreTypes.includes('magazine') && (
            <TabContent type="magazine" helpText={helpTexts.magazine} filter={{ book__type: 'magazine' }} />
          )}
          <TabPanel>
            <HStack paddingX="5%" w="100%" overflowX="auto">
              <BookGrid mutationHook={useMyReadingBooks} />
            </HStack>
          </TabPanel>
          <TabPanel>
            <HStack paddingX="5%" w="100%" overflowX="auto">
              <BookGrid mutationHook={useGetFavoritedBooksMutation} />
            </HStack>
          </TabPanel>
        </TabPanels>
      </TopBookstoreMenu>
    </MainTemplate>
  );
}
